import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-plus\">\n<path fill-rule=\"evenodd\" d=\"M9.999,6.000 L6.000,6.000 L6.000,10.000 L4.000,10.000 L4.000,6.000 L-0.000,6.000 L-0.000,4.000 L4.000,4.000 L4.000,-0.000 L6.000,-0.000 L6.000,4.000 L9.999,4.000 L9.999,6.000 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol